module.exports = __webpack_public_path__ + "img/com-redc.f6c71bc8.png";